const EMPTY_DISPLAY: IActivityLogDisplay = { mode: 'info', summary: '', items: [] }

export const ActivityLog = (json: IActivityLog): IActivityLogModel => {
	const occurredAt = json.occurred_at ?? json.created_at

	return {
		id: json.id,
		module: json.module,
		action: json.action,
		actionLabel: activityLogActionLabel(json.action),
		description: json.description,
		subjectType: json.subject_type,
		subjectId: json.subject_id,
		display: json.display ?? EMPTY_DISPLAY,
		causer: json.causer,
		source: json.source,
		actorId: json.actor_id,
		facilityId: json.facility_id,
		payload: json.payload,
		ip: json.ip,
		occurredAt: occurredAt ? new Date(occurredAt) : null,
	}
}
